/* Open the buyer's mail client with the product already written into the message. */
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-atlas-send]');
  if (!button) return;

  const subject = encodeURIComponent(button.dataset.subject || '');
  const body = encodeURIComponent(button.dataset.body || '');
  window.location.href = `mailto:?subject=${subject}&body=${body}`;
});
